import {createOffcanvasUI, OffcanvasUI} from './offcanvasUI';

export class Offcanvas {
  public constructor(private ui: OffcanvasUI) {
    this.ui.checkOffcanvasState(this.toggleScroll.bind(this))
  }

  public toggleScroll() {
    this.ui.checkScrollState();
  }
}

export function initOffcanvas() {
  const uiInstance = createOffcanvasUI();
  const instance = uiInstance.map((uiInstance: OffcanvasUI) => {
    return new Offcanvas(uiInstance);
  });
}

